import bigPizza from "./big-pizza.png"
import ecommerceSizeA from "./ecommerce-size-a.png"
import ecommerceSizeB from "./ecommerce-size-b.png"
import ecommerceSizeC from "./ecommerce-size-c.png"
import hebe from "./hebe.png"
import inpostSizeA from "./inpost-size-a.png"
import inpostSizeB from "./inpost-size-b.png"
import inpostSizeC from "./inpost-size-c.png"
import ownPackaging from "./own-packaging.png"
import standardDish from "./standard-dish.png"

export const PACKAGES_ASSETS = {
  "big-pizza": bigPizza,
  "standard-dish": standardDish,
  "own-packaging": ownPackaging,
  "medium-pizza": "",
  dinner: "",

  "hebe-box-1": hebe,
  "hebe-box-2": hebe,
  "hebe-box-3": hebe,
  "hebe-box-4": hebe,
  "hebe-box-5": hebe,

  "ecommerce-size-a": ecommerceSizeA,
  "ecommerce-size-b": ecommerceSizeB,
  "ecommerce-size-c": ecommerceSizeC,

  "inpost-size-a": inpostSizeA,
  "inpost-size-b": inpostSizeB,
  "inpost-size-c": inpostSizeC,
} as const
